_updateUserProfileImagesThunk